import { Division, Flex, Skeleton, Span } from "@ir/ui";

interface ProductsInScopeChipProps {
  isLoading: boolean;
}

const ProductsInScopeChip = ({ isLoading }: ProductsInScopeChipProps) => {
  if (isLoading) {
    return (
      <Division className="product-in-scope-icon">
        <Flex className="product-in-scope-icon-chip" align="center" gap={0.25}>
          <Skeleton height={12} width={12} variant="rounded" animation="wave" />
          <Skeleton height={10} width={160} variant="rounded" animation="wave" />
        </Flex>
      </Division>
    );
  }

  const label = "This promotion covers your full product catalog. Any SKU is eligible for deduction matching.";

  return (
    <Division className="product-in-scope-icon">
      <Flex className="product-in-scope-icon-chip" align="center" gap={0.25}>
        <svg
          className="deduction-intelligence-chip-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <g clipPath="url(#clip0_products_in_scope_chip)">
            <path
              d="M2.25 11V8.5M2.25 3.5V1M1 2.25H3.5M1 9.75H3.5M6.5 1.5L5.63291 3.75443C5.4919 4.12105 5.4214 4.30435 5.31176 4.45854C5.21459 4.5952 5.0952 4.71459 4.95854 4.81177C4.80435 4.9214 4.62105 4.99191 4.25443 5.13291L2 6L4.25443 6.86709C4.62105 7.00809 4.80435 7.0786 4.95854 7.18823C5.0952 7.28541 5.21459 7.4048 5.31177 7.54146C5.4214 7.69565 5.49191 7.87895 5.63291 8.24557L6.5 10.5L7.36709 8.24557C7.50809 7.87895 7.5786 7.69565 7.68824 7.54146C7.78541 7.4048 7.9048 7.28541 8.04146 7.18823C8.19565 7.0786 8.37895 7.00809 8.74557 6.86709L11 6L8.74557 5.13291C8.37895 4.99191 8.19565 4.9214 8.04146 4.81176C7.9048 4.71459 7.78541 4.5952 7.68823 4.45854C7.5786 4.30435 7.50809 4.12105 7.36709 3.75443L6.5 1.5Z"
              stroke="url(#paint0_linear_products_in_scope_chip)"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_products_in_scope_chip"
              x1="0.999844"
              y1="10.9999"
              x2="10.9999"
              y2="0.999878"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4300B1" />
              <stop offset="1" stopColor="#A531DC" />
            </linearGradient>
            <clipPath id="clip0_products_in_scope_chip">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <Span>{label}</Span>
      </Flex>
    </Division>
  );
};

export default ProductsInScopeChip;
